import { createFileRoute } from "@tanstack/react-router";
import { StudiosPage } from "@/views/public/studios/StudiosPage.tsx";

export const Route = createFileRoute("/_public/studios/")({
  component: StudiosPage,
});
